module.exports = __webpack_public_path__ + "static/media/Lunch.0d9cf907.png";